(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-or-video-in-text"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialized = new WeakSet();
  function initialize(root) {
    root.querySelectorAll('.media-text-fill__card--none').forEach(card => {
      if (initialized.has(card)) return;
      initialized.add(card);
      const media = card.querySelector('.media-text-fill__media');
      const spans = card.querySelectorAll('.media-text-fill__letters span');
      const draw = () => {
        const box = card.getBoundingClientRect();
        if (!box.width || !box.height) return;
        const scale = Math.min(window.devicePixelRatio || 1, 2);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(box.width * scale);
        canvas.height = Math.round(box.height * scale);
        const ctx = canvas.getContext('2d');
        ctx.scale(scale, scale);
        ctx.fillStyle = '#fff';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'middle';
        spans.forEach(span => {
          const rect = span.getBoundingClientRect();
          const style = getComputedStyle(span);
          ctx.font = [style.fontStyle, style.fontWeight, style.fontSize, style.fontFamily].join(' ');
          if ('letterSpacing' in ctx) ctx.letterSpacing = style.letterSpacing;
          ctx.fillText(span.textContent.trim().toLocaleUpperCase(), rect.left - box.left + rect.width / 2, rect.top - box.top + rect.height / 2);
        });
        const url = 'url("' + canvas.toDataURL('image/png') + '")';
        media.style.webkitMaskImage = url;
        media.style.maskImage = url;
      };
      new ResizeObserver(draw).observe(card);
      if (document.fonts) document.fonts.ready.then(draw);
      draw();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
